import * as React from 'react';
import { ToastNotificationContext } from '@app/Context/ToastNotificationContext';
import { Alert, AlertActionCloseButton, AlertGroup } from '@patternfly/react-core';
import { ToastNotificationType } from '@app/Interface/ToastNotificationInterface';

/**
 * Uses Context to get and update toast notifications 
 * @param children
 * @returns 
 */
const ToastNotifications: React.FC = ({ children }) => {

    // NOTE: ToastNotificationContext provider was added to `src\app\index.tsx`
    const { toastState, toastDispatch } = React.useContext(ToastNotificationContext);

    /**
     * Delete the toast notification from state
     * Only need id to delete.
     *  
     * @param id 
     */
    const deleteNotification = (id: number) => {

        // NOTE: Only need the id number.
        toastDispatch({
            type: "DELETE",
            payload: {
                id: id,
                title: "",
                type: ToastNotificationType.Default,
                description: ""
            }
        });

    }

    return (

        <>
            {toastState.toastNotices &&
                <div className="view-alert-group">
                    <AlertGroup
                        isToast
                        isLiveRegion
                    >
                        {toastState.toastNotices.map((notification, index) =>
                            <Alert
                                variant={notification.type}
                                key={index}
                                title={notification.title}
                                actionClose={<AlertActionCloseButton onClose={() => deleteNotification(notification.id)} />}
                                className="pf-u-m-md"
                                role="alert"
                            >
                                {/* TODO: If this is going to contain internal links, use htmlParser.htmlToJSX */}
                                <p dangerouslySetInnerHTML={{__html: notification.description}}></p>
                            </Alert>
                        )}
                    </AlertGroup>
                </div>
            }
            {children}
        </>
    );

};

export default ToastNotifications;